package br.com.vvrefeicoes.portal.feature.rh

import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.dp
import br.com.vvrefeicoes.portal.core.ui.components.EmptyState
import br.com.vvrefeicoes.portal.core.ui.theme.AppPalette
import br.com.vvrefeicoes.portal.domain.model.RhDismissed
import com.composables.icons.lucide.CircleAlert
import com.composables.icons.lucide.Lucide
import com.composables.icons.lucide.UserMinus
import com.composables.icons.lucide.Users
import org.jetbrains.compose.resources.stringResource
import portalvv.shared.generated.resources.Res
import portalvv.shared.generated.resources.rh_dismissed_by_reason
import portalvv.shared.generated.resources.rh_dismissed_by_sex
import portalvv.shared.generated.resources.rh_dismissed_distinct_jobs
import portalvv.shared.generated.resources.rh_dismissed_empty
import portalvv.shared.generated.resources.rh_dismissed_top_jobs
import portalvv.shared.generated.resources.rh_dismissed_top_reason
import portalvv.shared.generated.resources.rh_dismissed_top_units
import portalvv.shared.generated.resources.rh_dismissed_total

private val KPI_MIN_WIDTH = 240.dp
private val CARD_MIN_WIDTH = 430.dp

@Composable
fun RhDismissedContent(dismissed: RhDismissed) {
    if (dismissed.total == 0) {
        EmptyState(message = stringResource(Res.string.rh_dismissed_empty))
        return
    }
    val topReason = dismissed.byReason.firstOrNull()
    RhGrid(
        minColumnWidth = KPI_MIN_WIDTH,
        maxColumns = 3,
        items =
            listOf(
                { modifier ->
                    RhKpiTile(
                        icon = Lucide.UserMinus,
                        iconColor = AppPalette.Error500,
                        iconContainerColor = AppPalette.Error100,
                        label = stringResource(Res.string.rh_dismissed_total),
                        value = dismissed.total.toString(),
                        modifier = modifier,
                    )
                },
                { modifier ->
                    RhKpiTile(
                        icon = Lucide.CircleAlert,
                        iconColor = AppPalette.Warning500,
                        iconContainerColor = AppPalette.Warning100,
                        label = stringResource(Res.string.rh_dismissed_top_reason),
                        value = topReason?.label.orRhDash(),
                        hint = topReason?.count?.toString(),
                        modifier = modifier,
                    )
                },
                { modifier ->
                    RhKpiTile(
                        icon = Lucide.Users,
                        iconColor = AppPalette.Primary500,
                        iconContainerColor = AppPalette.Primary100,
                        label = stringResource(Res.string.rh_dismissed_distinct_jobs),
                        value = dismissed.distinctJobs.toString(),
                        modifier = modifier,
                    )
                },
            ),
    )
    RhGrid(
        minColumnWidth = CARD_MIN_WIDTH,
        maxColumns = 2,
        items =
            listOf(
                { modifier ->
                    RhDistributionCard(
                        title = stringResource(Res.string.rh_dismissed_by_reason),
                        items = dismissed.byReason,
                        color = AppPalette.Error500,
                        modifier = modifier,
                    )
                },
                { modifier ->
                    RhDistributionCard(
                        title = stringResource(Res.string.rh_dismissed_by_sex),
                        items = dismissed.bySex,
                        color = AppPalette.Info500,
                        modifier = modifier,
                    )
                },
                { modifier ->
                    RhDistributionCard(
                        title = stringResource(Res.string.rh_dismissed_top_jobs),
                        items = dismissed.topJobTitles,
                        color = AppPalette.Primary500,
                        modifier = modifier,
                    )
                },
                { modifier ->
                    RhDistributionCard(
                        title = stringResource(Res.string.rh_dismissed_top_units),
                        items = dismissed.topUnits,
                        color = AppPalette.Warning500,
                        modifier = modifier,
                    )
                },
            ),
    )
}
